import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

@Directive({})
export abstract class ViewColumnComponent<T = any> implements OnInit, OnDestroy {
  protected readonly index: number;
  protected compName: string;
  localState$: Observable<T>;

  targetServices;

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}

